export default {
  allocation: {
    button: {
      backToHome: "Back to allocations home",
    },
    title: "Allocations",
    titleAdditional:
      "Easily distribute listing allocations to help your team list and promote their properties.",
    individual: {
      summary:
        "Showing <strong>{listCount}</strong> results of {totalCount} total team members",
    },
    overview: {
      total: "Total",
      assigned: "Assigned",
      unassigned: "Unassigned",
      used: "Used",
      remaining: "Remaining",
      title: {
        agency: "Overview for {name}",
        branch: "Overview for your ",
      },
      button: {
        allocate: "Allocate",
        viewReport: "View report",
      },
      expireTitle: "Contract expiry",
      expireTip: "Unused upgrades and listings will expire by",
      expireTooltip:
        "The contract expiry refers to the last date that you can use your allocations to publish listings based on your contract’s end date.",
      internal: {
        tip: "Select an agency or branch to see all allocation details",
        placeholder: {
          agency: "Agency",
          branch: "Branch",
        },
      },
    },
    card: {
      premiumKey: "Premium",
      featureKey: "Feature",
      standardKey: "Standard",
      premiumPreKey: "P",
      featurePreKey: "F",
      standardPreKey: "S",
      moreDetail: {
        view: "View more details",
        hide: "Hide more details",
      },
    },

    noDataMessage: {
      main: "There are no agency or branch results.",
      addition: "Try selecting an agency or branch to see allocation results.",
    },

    noAuthMessage: {
      main: "This agency/branch doesn’t have allocations enabled.",
      addition:
        "If they require access to allocations, you can update their settings through agency/branch management.",
      accessBtn: "Update allocation access now",
    },

    listings: {
      title: "Branch allocations",
      button: {
        view: "View Members",
        allocation: "Allocate",
      },
      searchPlaceholder: "Search team member name",
    },
    transfer: {
      title: "Transfer allocations",
      description:
        "Simply select from and where you want to distribute upgrades and listings.",
      tier: {
        premium: "Premium",
        feature: "Feature",
        standard: "Standard",
      },
      search: {
        from: "From*",
        to: "To*",
        placeholder: "Search branch or member name",
      },
      summary: {
        title: "Allocation summary",
        defaultUser: "Choose a branch or member",
        from: "From",
        to: "To",
        balance: "Balance: ",
      },
      divide: {
        title: "Enter the amount you want to allocation",
        description:
          "<p>Remember, all properties are published as a Standard for 90days. When transfering upgrades and listings to team members, consider their total listing count.</p><p>If you need to revert a transfer, you can reallocate to another member or branch.</p>",
      },
      warn: {
        success: "Your transfer was successful!",
        server:
          "{name} doesn't have the amount you're wanting to allocation. Please check with your admin to clarify.",
        suggestion:
          "Please note, the recipients upgrade balance is going to be larger than their standard listing balance.",
        limit:
          "The available allocations is not enough to match the transfer. Please adjust the amount above.",
      },
      button: {
        allocate: "Allocate",
        back: "Back to allocations home",
      },
    },
    report: {
      title: "Allocation report",
      description: "History of all allocation transfers for {name}.",
      table: {
        columns: {
          member: "Member name",
          date: "Date",
          from: "From",
          to: "To",
          allocationInfo: "Allocated upgrades and listings",
        },
        pagination: "Viewing {begin} - {end} of {total} allocation results",
        emptyTitle: "There are no reporting results.",
        emptyDescription:
          "Check back once you have starting to allocate upgrades and listings.",
      },
    },
  },
};
